import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

const COACH_IMG = "https://customer-assets.emergentagent.com/job_0772848b-513c-4c6a-bb87-fb9de12093be/artifacts/602eb93p_Screenshot%202026-05-18%20at%2011.34.30%E2%80%AFAM.png";

export default function Splash() {
  const nav = useNavigate();
  const { user, loading } = useAuth();

  // Auto-redirect logged-in athletes straight to their dashboard
  useEffect(() => {
    if (!loading && user) {
      nav(user.role === "admin" ? "/admin" : "/app/dashboard", { replace: true });
    }
  }, [loading, user, nav]);

  if (loading || user) return <div className="min-h-screen bg-[#070707]" data-testid="splash-loading" />;
  return (
    <div className="min-h-screen relative overflow-hidden bg-[#070707] text-white" data-testid="splash-page">
      {/* Hero image background */}
      <div className="absolute inset-0">
        <img src={COACH_IMG} alt="Coach JP" className="w-full h-full object-cover object-center opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#070707]/40 via-[#070707]/60 to-[#070707]" />
        <div className="absolute inset-0 jp-grain opacity-40" />
      </div>

      <div className="relative z-10 min-h-screen flex flex-col">
        <div className="px-6 pt-8">
          <div className="font-mono-jp text-[10px] uppercase tracking-[0.4em] text-[#888]">EST. KUALA LUMPUR · MALAYSIA</div>
        </div>

        <div className="flex-1 flex flex-col justify-end px-6 pb-16 sm:pb-20">
          <div className="max-w-3xl">
            <div className="font-mono-jp text-xs uppercase tracking-[0.3em] text-[#d7ff00] mb-3" data-testid="splash-eyebrow">FORMER FRENCH NATIONAL TEAM RUNNER · ELITE COACH</div>
            <h1 className="font-display text-[18vw] sm:text-[12rem] leading-[0.85] tracking-tight uppercase">
              COACH
              <br />
              <span className="text-[#d7ff00]">JP</span>
            </h1>
            <p className="mt-6 font-display text-3xl sm:text-5xl uppercase leading-none">
              Smarter Training.
              <br />
              <span className="text-[#d7ff00]">Stronger You.</span>
            </p>
            <p className="mt-6 max-w-md text-[#bbb] text-sm sm:text-base leading-relaxed">
              Personalized running coaching to help you perform at your best — and enjoy the process. From your first 5K to your fastest marathon.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <button onClick={() => nav("/pricing")} className="bg-[#d7ff00] text-black font-display tracking-wider uppercase text-xl px-8 py-4 hover:bg-white transition-colors active:scale-[0.98]" data-testid="get-started-btn">
                Get Started
              </button>
              <button onClick={() => nav("/about")} className="bg-transparent border border-[#d7ff00] text-[#d7ff00] font-display tracking-wider uppercase text-xl px-8 py-4 hover:bg-[#d7ff00]/10 active:scale-[0.98]" data-testid="about-coach-btn">
                About the Coach
              </button>
            </div>

            <div className="mt-12 max-w-md">
              <div className="border-l-2 border-[#d7ff00] pl-4">
                <p className="font-display text-2xl sm:text-3xl uppercase leading-tight">
                  Train the body.<br />
                  Discipline the <span className="text-[#d7ff00]">mind</span>.<br />
                  Transform <span className="text-[#d7ff00]">both</span>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
